<div v-if="token_exists" class="suggestions-card rounded d-none d-xl-block">
  <div class="suggestions-header">
    <h6 class="suggestions-title mb-0">Suggested Friends</h6>
   
  </div>

  <div v-if="filtered_users.length <= 0" class="suggestions-empty">
    No personal profiles found.
  </div>

  <div
    v-for="user in filtered_users"
    :key="user.id"
    class="suggestion-row"
    role="button"
    tabindex="0"
    @click="view_profile(user)"
    @keydown.enter="view_profile(user)"
  >
    <img
      v-if="get_user_avatar(user)"
      :src="get_user_avatar(user)"
      class="suggestion-avatar"
      alt="Profile"
    />
    <span v-else class="suggestion-avatar suggestion-initials">
      {{ get_user_initials(user) }}
    </span>

    <span class="suggestion-copy">
      <span class="suggestion-name">
        {{ get_user_name(user) }}
      </span>
      <span class="suggestion-meta">
        {{ get_user_meta(user) }}
      </span>
    </span>

    <button
      type="button"
      class="suggestion-action"
      :class="{ 'is-followed': is_followed_user(user) }"
      :disabled="is_following_user(user)"
      @click.stop="follow_profile(user)"
    >
      {{ get_follow_label(user) }}
    </button>
  </div>
   <div v-if="filtered_users.length > 4" class="text-end">
    <a class="suggestions-see-all" href="/view_personal_profiles">
      See all
    </a>
  </div>
</div>
